import React, { useEffect } from 'react'
import Layout from './layout/layout'
import { useRouter } from 'next/navigation'
import CustomRedirectText from './customRedirectText'

type CustomRedirectProps = {
  url: string
  renderLayout?: boolean
  loading?: boolean
}

const CustomRedirect = ({ renderLayout, url, loading }: CustomRedirectProps) => {
  useEffect(() => {
    if (!loading) {
      router.push(url)
    }
  }, [])

  const router = useRouter()
  const redirectWithTranslation = loading && <CustomRedirectText />

  if (renderLayout) {
    return <Layout>{redirectWithTranslation}</Layout>
  }

  return redirectWithTranslation
}

export default CustomRedirect
